// script.js (capsule index.html) ~sdg
'use strict'
console.time('LoadTime')
import './normalize.css'
import './style.css'
import * as THREE from 'three'
//import { LatheGeometry } from 'three/examples/src/geometries/CapsuleGeometry.js'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
// Canvas
const canvas = document.querySelector('canvas.webgl')
// Scene
const scene = new THREE.Scene()

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight
}
// Resize
window.addEventListener('resize', () =>
{
  // Update sizes
  sizes.width = window.innerWidth
  sizes.height = window.innerHeight
  // Update camera
  camera.aspect = sizes.width / sizes.height
  camera.updateProjectionMatrix()
  // Update renderer
  renderer.setSize(sizes.width, sizes.height)
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(50, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 3
camera.position.y = 3
camera.position.z = 3

scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.minDistance = 2
controls.maxDistance = 90

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({ canvas: canvas })
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Objects
 */
// Lathe
const points = []
points.push( new THREE.Vector2( 0, 1 ) )
points.push( new THREE.Vector2( 0.2, 0.5 ) )
points.push( new THREE.Vector2( 1, 0 ) )
points.push( new THREE.Vector2( 1, - 0.1 ) )
points.push( new THREE.Vector2( 0.5, - 0.6 ) )
points.push( new THREE.Vector2( 0.25, - 1.5 ) )
points.push( new THREE.Vector2( 0.0, - 1.4 ) )

const geometry = new THREE.LatheGeometry(points, 24, 0, Math.PI * 2)
const material = new THREE.MeshNormalMaterial({ wireframe: true, flatShading: false })
const lathe = new THREE.Mesh(geometry, material)
lathe.rotation.x = - Math.PI * 0.25
scene.add(lathe)

/**
 * Animate
 */
const clock = new THREE.Clock()
const animate = () =>
{
  const elapsedTime = clock.getElapsedTime()
  // Update Controls
  controls.update()
  // Rotate Lathe
  lathe.rotation.y = elapsedTime * 0.2
  // Render
  renderer.render(scene, camera)
  window.requestAnimationFrame(animate)
}
animate()
console.timeEnd('LoadTime')
// EOF script.js (capsule index.html) ~sdg